import React, { useContext, useEffect, useState } from "react";
import { CommonModal } from "../../../AbstractElements";
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  Table,
} from "reactstrap";
import { useForm, useController } from "react-hook-form";
import CustomizerContext from "../../../_helper/Customizer";
import CustomSelect from "../../../CommonElements/CustomSelect";
import {
  CreateVendorPost,
  getParentCompany,
  getVendor,
  UpdateVendorPost,
} from "../../../Services/Ventor.service";
import { showAlert } from "../../../Services/Shared.service";

const CreateVendor = ({
  Large,
  title,
  LargeModaltoggle,
  cityDataList,
  editId,
}) => {
  const { mix_background_layout } = useContext(CustomizerContext);
  const [megaCabsCompanyLists, setmegaCabsCompanyLists] = useState([]);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    trigger,
    clearErrors,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      sapGlCode: "",
      companyName: "",
      contactPersonName: "",
      mobile: "",
      email: "",
      addressLine: "",
      city: "",
      state: "",
      pincode: "",
      serviceCity: "",
      cinNo: "",
      panNo: "",
      serviceTaxNo: "",
      phone1: "",
      phone2: "",
      isMegaCabsCompany: false,
      parentCompanyName: "",
      userId:""
    },
  });

  const isMegaCabsCompanyField = useController({
    name: "isMegaCabsCompany",
    control,
    rules: {},
  }).field;
  const serviceCityField = useController({
    name: "serviceCity",
    control,
    rules: {
      required: {
        value: true,
        message: "Service City is Required",
      },
    },
  }).field;
  const parentCompanyNameField = useController({
    name: "parentCompanyName",
    control,
    rules: {
      required: {},
    },
  }).field;
  // ====helpers
  const cityData = cityDataList ? cityDataList : [];

  const handleCitySelectChange = (data) => {
    serviceCityField.onChange(data.value);
  };

  const handleMegaCabsCompanyLists = (data) => {
    parentCompanyNameField.onChange(data);
  //  let a= megaCabsCompanyLists.find((element) => {
  //   return (
  //     element.value === getValues("parentCompanyName").value
  //   );
  // })
  //   console.log("list===",megaCabsCompanyLists[5],"0909 data",data)
  };

  useEffect(() => {
    getParentCompany().then((result) => {
      if (result.data) {
        const data = result.data.map((element) => {
          return {
            label: element.companyName,
            value: element.id,
          };
        });
        data.unshift({ label: "No parent Company", value: null });
        setmegaCabsCompanyLists(data);
      }
    });
  }, []);
  const { isMegaCabsCompany, parentCompanyName } = watch();

  useEffect(() => {
    if (isMegaCabsCompany) {
      const result = megaCabsCompanyLists.find(
        (item) => item.label === "Mega Cabs Pvt. Ltd."
      );
      setValue("parentCompanyName",result);
      console.log("ress",result)
    } else {
      setValue("parentCompanyName", {
        label: "No parent Company",
        value: null,
      });
    }
    console.log("ress",getValues("parentCompanyName"))

  }, [isMegaCabsCompany]);

  //  ========on edit==
  useEffect(() => {
    if (!!editId) {
      getVendor(editId)
        .then((res) => {
          if (res.data) {
            reset({
              sapGlCode: res.data.sapGlCode ? res.data.sapGlCode : "",
              companyName:res.data.companyName ? res.data.companyName : "",
              contactPersonName: res.data.contactPersonName
                ? res.data.contactPersonName
                : "",
              mobile:res.data.mobile ? res.data.mobile : "",
              email: res.data.email ? res.data.email : "",
              addressLine: res.data.addressLine ? res.data.addressLine : "",
              city: res.data.city ? res.data.city : "",
              state: res.data.state ? res.data.state : "",
              pincode: res.data.pincode ? res.data.pincode : "",
              serviceCity: res.data.serviceCityId
                ? serviceCityDataFrezzer(res.data)
                : "",
              cinNo: res.data.cinNo ? res.data.cinNo : "",
              panNo: res.data.panNo ? res.data.panNo : "",
              serviceTaxNo: res.data.serviceTaxNo ? res.data.serviceTaxNo : "",
              phone1: res.data.phone1 ? res.data.phone1 : "",
              phone2: res.data.phone2 ? res.data.phone2 : "",
              isMegaCabsCompany: res.data.isMegaCabsCompany ? true : false,
              parentCompanyName:parentCompanyNameFrezzer(res.data),
              parentId: res.data.parentId
                ? res.data.parentId
                : "",
                userId:res.data?.userId ?res.data?.userId :null,
                createdOn:res.data?.createdOn ?res.data?.createdOn : null,
                createdById: res.data?.createdById ?res.data?.createdById : null,
                updatedOn: res.data?.updatedOn ?res.data?.updatedOn : null,
                updatedById: res.data?.updatedById ?res.data?.updatedById : null,
                deletedOn: res.data?.deletedOn ?res.data?.deletedOn : null,
                isDeleted:res.data?.isDeleted ?true :  false,
                deletedById: res.data?.deletedById ?res.data?.deletedById : null,
            
            
            });
          }
        })
        .catch((err) => {

          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong "
          );
        });
    }
  }, [editId]);

  // ==helper
  const serviceCityDataFrezzer=(data)=>{
    return cityData.find((element) => {
      return element?.value?.id === data?.serviceCityId
    })
  }
  const parentCompanyNameFrezzer=(data)=>{
    return{label:data.parentCompanyName,
      value:data.parentId
    }
  }


  
  // ====on submit=-------------------------------------
  const onFormSubmit = (formValues) => {
    console.log("formValues", formValues);
    const body = {
      id: editId,
      sapGlCode: formValues.sapGlCode ? formValues.sapGlCode : null,
      companyName: formValues.companyName ? formValues.companyName : null,
      contactPersonName: formValues.contactPersonName
        ? formValues.contactPersonName
        : null,
      mobile: formValues.mobile ? formValues.mobile : null,
      email: formValues.email ? formValues.email : null,
      addressLine: formValues.addressLine ? formValues.addressLine : null,
      city: formValues.city ? formValues.city : null,
      state: formValues.state ? formValues.state : null,
      pincode: formValues.pincode ? formValues.pincode : null,
      serviceCityId: formValues.serviceCity ? formValues.serviceCity.id : null,
      cinNo: formValues.cinNo ? formValues.cinNo : null,
      panNo: formValues.panNo ? formValues.panNo : null,
      serviceTaxNo: formValues.serviceTaxNo ? formValues.serviceTaxNo : null,
      phone1: formValues.phone1 ? formValues.phone1 : null,
      phone2: formValues.phone2 ? formValues.phone2 : null,
      isMegaCabsCompany: formValues.isMegaCabsCompany ? true : false,
      parentCompanyName: formValues.parentCompanyName
        ? formValues.parentCompanyName?.label
        : null,
      parentId: formValues?.parentCompanyName
        ? formValues.parentCompanyName?.value
        : null,
        userId:formValues.userId ? formValues.userId : null,

        createdOn:formValues?.createdOn ?formValues?.createdOn : null,
        createdById: formValues?.createdById ?formValues?.createdById : null,
        updatedOn: formValues?.updatedOn ?formValues?.updatedOn : null,
        updatedById: formValues?.updatedById ?formValues?.updatedById : null,
        deletedOn: formValues?.deletedOn ?formValues?.deletedOn : null,
        isDeleted:formValues?.isDeleted ?true :  false,
        deletedById: formValues?.deletedById ?formValues?.deletedById : null,

    };
    console.log("formValues", body);
if(editId){
  UpdateVendorPost(body).then((res) => {
    showAlert("success", "Vendor Updated successfully");
    reset({
      sapGlCode: "",
      companyName: "",
      contactPersonName: "",
      mobile: "",
      email: "",
      addressLine: "",
      city: "",
      state: "",
      pincode: "",
      serviceCity: "",
      cinNo: "",
      panNo: "",
      serviceTaxNo: "",
      phone1: "",
      phone2: "",
      isMegaCabsCompany: false,
      parentCompanyName: "",
      userId:"",
      createdOn:"",
      createdById:"",
      updatedOn: "",
      updatedById: "",
      deletedOn: "",
      isDeleted:"",
      deletedById: "",
    });
    LargeModaltoggle()
  })
  .catch((err) => {
    showAlert(
      "error",
      err.response?.data?.message
        ? err.response.data.message
        : "Something went wrong"
    );
  });
  
}else{
    CreateVendorPost(body)
      .then((res) => {
        showAlert("success", "Vendor Created successfully");
        reset({
          sapGlCode: "",
          companyName: "",
          contactPersonName: "",
          mobile: "",
          email: "",
          addressLine: "",
          city: "",
          state: "",
          pincode: "",
          serviceCity: "",
          cinNo: "",
          panNo: "",
          serviceTaxNo: "",
          phone1: "",
          phone2: "",
          isMegaCabsCompany: false,
          parentCompanyName: "",
          userId:"",
          createdOn:"",
          createdById:"",
          updatedOn: "",
          updatedById: "",
          deletedOn: "",
          isDeleted:"",
          deletedById: "",
        });
        LargeModaltoggle()
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
      });
    }
  };
  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={() => {
        reset({
          sapGlCode: "",
          companyName: "",
          contactPersonName: "",
          mobile: "",
          email: "",
          addressLine: "",
          city: "",
          state: "",
          pincode: "",
          serviceCity: "",
          cinNo: "",
          panNo: "",
          serviceTaxNo: "",
          phone1: "",
          phone2: "",
          isMegaCabsCompany: false,
          parentCompanyName: "",
          userId:"",
          createdOn:"",
          createdById:"",
          updatedOn: "",
          updatedById: "",
          deletedOn: "",
          isDeleted:"",
          deletedById: "",
        });

        LargeModaltoggle();
      }}
      size="xl"
    >
      <Form onSubmit={handleSubmit(onFormSubmit)} className="create-driver">
        <Row>
          <div style={{ fontSize: "18px", fontWeight: "500" }}>
            Vendor Information
          </div>
        </Row>
        <Row>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Company</Label>
            <Col className="col-lg-12">
              <input
                className="form-control"
                {...register("companyName", {
                  required: {
                    value: true,
                    message: "Vendor Name is required",
                  },
                  onChange: (e) => {
                    setValue("companyName", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>
                {errors?.companyName?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">
              Contact Person Name
            </Label>
            <Col className="col-lg-12">
              <input
                className="form-control"
                {...register("contactPersonName", {
                  required: {
                    value: true,
                    message: "Contact Person  Name is required",
                  },
                  onChange: (e) => {
                    setValue("contactPersonName", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>
                {errors?.contactPersonName?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Mobile</Label>
            <Col className="col-lg-12">
              <input
                maxLength={10}
                placeholder="Vendor Mobile"
                className="form-control"
                pattern="[0-9]+"
                {...register("mobile", {
                  required: {
                    value: true,
                    message: "Mobile number is required",
                  },
                  onChange: (e) => {
                    setValue("mobile", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.mobile?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Email</Label>
            <Col lg="12">
              <input
                className="form-control"
                disabled={title === "Update Vendor" ? true : false}
                type="text"
                {...register("email", {
                  onChange: (e) => {
                    setValue("email", e.target.value.trimStart());
                  },
                  required: {
                    value: true,
                    message: "Email is required",
                  },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Please enter a valid email !",
                  },
                })}
              />
              <span style={{ color: "red" }}>{errors?.email?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Company Address</Label>
            <Col lg="12">
              <input
                className="form-control"
                {...register("addressLine", {
                  required: {
                    value: true,
                    message: "Address Line is required",
                  },
                  onChange: (e) => {
                    setValue("addressLine", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>
                {errors?.addressLine?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">City</Label>
            <Col lg="12">
              <input
                className="form-control"
                {...register("city", {
                  required: {
                    value: true,
                    message: "City is required",
                  },
                  onChange: (e) => {
                    setValue("city", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.city?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">State</Label>
            <Col lg="12">
              <input
                className="form-control"
                {...register("state", {
                  required: {
                    value: true,
                    message: "State is required",
                  },
                  onChange: (e) => {
                    setValue("state", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.state?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Pin Code</Label>
            <Col lg="12">
              <input
                className="form-control"
                {...register("pincode", {
                  required: {
                    value: true,
                    message: "Pin code is required",
                  },
                  validate: (value) =>
                    value.length == 6 || "Pin Code must be 6 numbers",
                  onChange: (e) => {
                    setValue("pincode", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.pincode?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">CIN No.</Label>

            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("cinNo", {
                  //   required: {
                  //     value: true,
                  //     message: "CIN No is required",
                  //   },
                  onChange: (e) => {
                    setValue("cinNo", e.target.value.trimStart());
                  },
                  validate: (value) =>
                    value.length == 21 || "CIN No must be 21 characters",
                })}
              />

              <span style={{ color: "red" }}>{errors?.cinNo?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">PAN No.</Label>

            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("panNo", {
                  required: {
                    value: true,
                    message: "PAN No is required",
                  },
                  onChange: (e) => {
                    setValue("panNo", e.target.value.trimStart());
                  },
                  validate: (value) =>
                    value.length == 10 || "panNo No must be 10 characters",
                })}
              />

              <span style={{ color: "red" }}>{errors?.panNo?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Service Tax No</Label>

            <Col lg="12">
              <input
                className="form-control"
                type="text"
                {...register("serviceTaxNo", {
                  //   required: {
                  //     value: true,
                  //     message: "Service Tax No is required",
                  //   },
                  onChange: (e) => {
                    setValue("serviceTaxNo", e.target.value.trimStart());
                  },
                  validate: (value) =>
                    value.length == 15 ||
                    "Service Tax No must be 15 characters",
                })}
              />

              <span style={{ color: "red" }}>
                {errors?.serviceTaxNo?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Phone 1</Label>
            <Col className="col-lg-12">
              <input
                maxLength={10}
                placeholder="Phone number"
                className="form-control"
                pattern="[0-9]+"
                {...register("phone1", {
                  onChange: (e) => {
                    setValue("phone1", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.phone1?.message}</span>
            </Col>
          </FormGroup>
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Phone 2</Label>
            <Col className="col-lg-12">
              <input
                maxLength={10}
                placeholder="Phone number"
                className="form-control"
                pattern="[0-9]+"
                {...register("phone2", {
                  onChange: (e) => {
                    setValue("phone2", e.target.value.trimStart());
                  },
                })}
                type="text"
              />
              <span style={{ color: "red" }}>{errors?.phone1?.message}</span>
            </Col>
          </FormGroup>
         
          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">Service City</Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={cityData.find((element) => {
                    return element?.value?.id === serviceCityField?.value?.id;
                  })}
                  // isDisabled={editId ? true : false}
                  onChange={handleCitySelectChange}
                  placeholder="Select City"
                  options={cityData}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.serviceCity?.message}
              </span>
            </Col>
          </FormGroup>
          <FormGroup
            className="col-lg-3"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{ display: "flex", alignItems: "center" }}
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
            >
              <Input
                id="isAvailable"
                type="checkbox"
                checked={isMegaCabsCompanyField.value}
                onChange={(value) => isMegaCabsCompanyField.onChange(value)}
              />
              <Label className="mb-0" for="isAvailable">
                Is Mega cabs Company
              </Label>
            </div>
          </FormGroup>

          <FormGroup className="col-lg-3">
            <Label className="col-lg-12 col-form-label">
              Parent Company Name
            </Label>
            <Col className="col-lg-12">
              <CustomSelect
                className="driver-type-select"
                classNamePrefix="driver-type-select-options"
                isClearable={false}
                isSearchable={false}
                isDisabled={isMegaCabsCompany}
                value={
                    // getValues("parentCompanyName")
                    megaCabsCompanyLists.find((element) => {
                  return (
                    element.value === getValues("parentCompanyName").value
                  );
                })
            }
                onChange={handleMegaCabsCompanyLists}
                placeholder="Select parent company"
                options={megaCabsCompanyLists}
              />
              <span style={{ color: "red" }}>
                {errors?.parentCompanyName?.message}
              </span>
            </Col>
          </FormGroup>
          
        </Row>
        <Row className="submit-driver">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "5px",
            }}
          >
            <button type="submit" className="btn submit-button">
            {editId ? "Update" : "Create"}
            </button>
          </div>
        </Row>
      </Form>
    </CommonModal>
  );
};

export default CreateVendor;
